// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
fieldset[data-v-467c5b65] {
    display: flex;
    flex-direction: column;
    margin-bottom: 1em;
}
@media (min-width: 1200px) {
fieldset[data-v-467c5b65] {
        flex-direction: row;
}
}
.input-container > *[data-v-467c5b65] {
    margin: 0;
}
fieldset > .input-container[data-v-467c5b65] {
    display: flex;
    flex: 1;
    flex-direction: row;
}
fieldset > label[data-v-467c5b65] {
    display: inline-block;
    width: 10em;
    height: 34px;
    font-weight: bold;
    line-height: 17px;
    vertical-align: top;
}
@media (max-width: 1199px) {
fieldset > label[data-v-467c5b65] {
        display: block;
}
}
.input-container > input[data-v-467c5b65] {
    flex: 1;
    border-right: 0;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}
.input-container > input + button[data-v-467c5b65] {
    width: 3em;
    border-radius: 0 var(--border-radius) var(--border-radius) 0;
}
.input-container > input + button > *[data-v-467c5b65] {
    pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/FormComponents/EditImageField.vue"],"names":[],"mappings":";AA0DA;IACA,aAAA;IACA,sBAAA;IACA,kBAAA;AACA;AAEA;AACA;QACA,mBAAA;AACA;AACA;AAEA;IACA,SAAA;AACA;AAEA;IACA,aAAA;IACA,OAAA;IACA,mBAAA;AACA;AAEA;IACA,qBAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;IACA,iBAAA;IACA,mBAAA;AACA;AACA;AACA;QACA,cAAA;AACA;AACA;AAEA;IACA,OAAA;IACA,eAAA;IACA,6BAAA;IACA,0BAAA;AACA;AAEA;IACA,UAAA;IACA,4DAAA;AACA;AAEA;IACA,oBAAA;AACA","sourcesContent":["<template>\n    <fieldset>\n        <label>\n            {{ fieldLabel }}\n        </label>\n        <div class=\"input-container\">\n            <input\n                type=\"text\"\n                :value=\"value\"\n                :placeholder=\"\n                    // prettier-ignore\n                    t('cookbook', 'Enter URL or select from your Nextcloud instance on the right')\n                \"\n                @input=\"$emit('input', $event.target.value)\"\n            />\n            <button\n                type=\"button\"\n                :title=\"t('cookbook', 'Pick a local image')\"\n                @click=\"pickImage\"\n            >\n                <span class=\"icon-category-multimedia\"></span>\n            </button>\n        </div>\n    </fieldset>\n</template>\n\n<script setup>\nimport { FilePickerType, getFilePickerBuilder } from '@nextcloud/dialogs';\nimport { defineProps } from 'vue';\n\nconst emit = defineEmits(['input']);\ndefineProps({\n    value: { type: String, default: '' },\n    fieldLabel: { type: String, default: '' },\n});\n\nconst pickImage = (e) => {\n    e.preventDefault();\n    const filePicker = getFilePickerBuilder(\n        t('cookbook', 'Path to your recipe image'),\n    )\n        .addMimeTypeFilter('image/jpeg')\n        .addMimeTypeFilter('image/png')\n        .setType(FilePickerType.Choose)\n        .build();\n    filePicker.pick().then((path) => {\n        emit('input', path);\n    });\n};\n</script>\n\n<script>\nexport default {\n    name: 'EditImageField',\n};\n</script>\n\n<style scoped>\nfieldset {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 1em;\n}\n\n@media (min-width: 1200px) {\n    fieldset {\n        flex-direction: row;\n    }\n}\n\n.input-container > * {\n    margin: 0;\n}\n\nfieldset > .input-container {\n    display: flex;\n    flex: 1;\n    flex-direction: row;\n}\n\nfieldset > label {\n    display: inline-block;\n    width: 10em;\n    height: 34px;\n    font-weight: bold;\n    line-height: 17px;\n    vertical-align: top;\n}\n@media (max-width: 1199px) {\n    fieldset > label {\n        display: block;\n    }\n}\n\n.input-container > input {\n    flex: 1;\n    border-right: 0;\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n}\n\n.input-container > input + button {\n    width: 3em;\n    border-radius: 0 var(--border-radius) var(--border-radius) 0;\n}\n\n.input-container > input + button > * {\n    pointer-events: none;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
